import React, { FunctionComponent } from 'react'
import { EVENT } from '../../../constants'
import { canRemoveCustomerFromSale } from '../../../functions/sale'
import { useSaleManager } from '../../../ng-compat/hooks'
import { $rootScope } from '../../../ng-compat/imports'
import { useAppSelector } from '../../../state/hooks'
import { selectCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'
import { usePaymentRecalculationLock } from '../payment-panel/PaymentRecalculationLockContext'
import { DeleteButton } from '../../shared/DeleteButton'

interface RemoveCustomerProps {
  onCustomerRemoved?: () => void
}

export const RemoveCustomerButton: FunctionComponent<RemoveCustomerProps> = ({
  onCustomerRemoved,
}) => {
  const sale = useAppSelector(selectCurrentSale)
  const saleManager = useSaleManager()
  const {
    lockPaymentActionsUntilRecalculationCompletes,
  } = usePaymentRecalculationLock()

  const removeCustomer = async () => {
    lockPaymentActionsUntilRecalculationCompletes()
    await saleManager.removeCustomer()
    $rootScope.$emit(EVENT.SALE_UPDATE_TENDERED_AMOUNT)
    if (onCustomerRemoved) {
      onCustomerRemoved()
    }
  }

  const handleCustomerRemove = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    removeCustomer()
  }

  if (!canRemoveCustomerFromSale(sale)) {
    return null
  }

  return (
    <div className="wr-customer-badge-remove-wrapper vd-mt0 vd-mb0">
      <DeleteButton
        variant="no"
        type="button"
        modifier="icon"
        onClick={handleCustomerRemove}
        data-track="remove-customer"
        className="wr-customer-badge-remove"
        customDataAttributes={{
          root: { 'data-track': 'remove-customer' },
        }}
        customClasses={{ root: ['wr-customer-badge-remove'] }}
      />
    </div>
  )
}
